// Copied from src/composables/useScopeInputs.ts so it lives next to the wizard files
import { reactive, computed } from 'vue';
import { getField, setField, clearField, clearAll } from '@/services/secureStorage/scopeStorage';

export const SCOPE_FIELDS = [
  'strengths',
  'passions',
  'problems',
  'jobs',
  'careers',
  'skills',
  'tools',
  'deliverables',
  'goals',
  'user',
  'upload'
] as const;

export type ScopeFieldKey = (typeof SCOPE_FIELDS)[number];

interface SavedInputs {
  [key: string]: string;
}

export function useScopeInputs() {
  const savedInputs = reactive<SavedInputs>({});
  SCOPE_FIELDS.forEach(key => {
    savedInputs[key] = getField(key) || '';
  });

  const savedInputsFlags = reactive<Record<ScopeFieldKey, boolean>>({
    strengths: false,
    passions: false,
    problems: false,
    jobs: false,
    careers: false,
    skills: false,
    tools: false,
    deliverables: false,
    goals: false,
    user: false,
    upload: false
  });

  const hasAnySavedInputs = computed(() => Object.values(savedInputs).some(v => v && v.length > 0));

  function clearSpecificField(key: ScopeFieldKey) {
    savedInputs[key] = '';
    clearField(key);
  }

  function saveField(key: ScopeFieldKey, value: string) {
    if (value.trim()) {
      savedInputs[key] = value.trim();
      setField(key, value.trim());
    } else {
      clearSpecificField(key);
    }
  }

  function clearAllFields() {
    SCOPE_FIELDS.forEach(key => {
      savedInputs[key] = '';
    });
    clearAll([...SCOPE_FIELDS]);
  }

  return {
    savedInputs,
    savedInputsFlags,
    hasAnySavedInputs,
    saveField,
    clearSpecificField,
    clearAllFields
  };
}
